namespace $.$$ {

	export class $hyoo_intern_catalog_companies extends $.$hyoo_intern_catalog_companies {

	}

}
